import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Toaster, toast } from "sonner";
import { adminLogin } from "../lib/api";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await adminLogin(email, password);
      localStorage.setItem("tf_admin_email", res.data.email);
      toast.success("Welcome back.");
      navigate("/admin");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="admin-login-page" className="min-h-screen bg-[#FAF5EC] flex items-center justify-center px-6">
      <Toaster theme="light" position="top-center" />
      <div className="w-full max-w-md">
        <div className="text-center mb-10">
          <p className="eyebrow mb-3">Administration</p>
          <h1 className="font-serif-display text-4xl tracking-tight">Time Furniture</h1>
        </div>

        <form onSubmit={onSubmit} className="border border-[#6E1F2C]/15 bg-white p-8 space-y-5">
          <div>
            <label htmlFor="al-email" className="block text-[10px] tracking-[0.28em] uppercase text-[#7A6B5F] mb-3">
              Email
            </label>
            <input
              id="al-email"
              type="email"
              data-testid="admin-email-input"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="w-full bg-[#FAF5EC] border border-[#6E1F2C]/25 px-4 py-3 text-[#1C110C] text-sm focus-gold"
            />
          </div>
          <div>
            <label htmlFor="al-pw" className="block text-[10px] tracking-[0.28em] uppercase text-[#7A6B5F] mb-3">
              Password
            </label>
            <input
              id="al-pw"
              type="password"
              data-testid="admin-password-input"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              className="w-full bg-[#FAF5EC] border border-[#6E1F2C]/25 px-4 py-3 text-[#1C110C] text-sm focus-gold"
            />
          </div>
          <button
            type="submit"
            disabled={loading}
            data-testid="admin-login-submit"
            className="w-full bg-[#6E1F2C] text-[#FAF5EC] px-8 py-4 text-[11px] tracking-[0.28em] uppercase hover:bg-[#56151F] transition-colors disabled:opacity-60"
          >
            {loading ? "Signing in..." : "Sign In"}
          </button>
        </form>

        <p className="text-center text-xs text-[#9A8A7F] mt-6">
          Return to <a href="/" className="link-elegant text-[#6E1F2C]">timefurniture.ae</a>
        </p>
      </div>
    </div>
  );
}
